// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--Nd892";
export var footer = "Footer-module--footer--3qxhf";